import { render, staticRenderFns } from "./DeletedDataField.vue?vue&type=template&id=651e860e"
import script from "./DeletedDataField.vue?vue&type=script&lang=ts"
export * from "./DeletedDataField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports